export default "__VITE_PUBLIC_ASSET__5fd67253__"